const requestToServer = async (type, options) => {
  return new Promise(function(resolve, reject) {
    let formData = new FormData();
    formData.append( "type", type );

    if(options){
      for (const [key, value] of Object.entries(options)) {
        formData.append( key, value );
      }
    }

    fetch(`${process.env.REACT_APP_SERVER_BACK_URL}/server.php?key=${process.env.REACT_APP_SERVER_BACK_KEY}`, {
      method: 'POST',
      body: formData,
    })
      .then(response => response.json())
      .then(req => {
        if(req.errors){
          // console.error(req.errors, 'errors')
          reject(req.errors);
        }
        else{
          // console.log(req?.data, 'data')
          resolve(req?.data)
        }
      })
      .catch(err => {
        // console.error(err, 'err')
        reject(err)
      })
  })
};

export default requestToServer;
